export const educationData = [
    {
        id: 1,
        institution: 'University of Wroclaw',
        course: 'Computer Science',
        startYear: '2016',
        endYear: '2022'
    }
]